// extracted by mini-css-extract-plugin
export default {"home":"mobile_home__PIrq2","hero":"mobile_hero__LylPV"};